import React, { useState, useEffect, useRef } from 'react';
import ReCAPTCHA from "react-google-recaptcha";
import LoadingButton from '@mui/lab/LoadingButton';
import SaveIcon from '@mui/icons-material/Save';
import PlayerForm from '../player.form';
import PlayerSummerTourForm from '../player.summertour.form';
import ValidationFeedback from '../validation.feedback';

import GoogleSheetsService from '../../service/googlesheet.service';

let resetInfoTimeoutId = -1;

const HandleCompetitionBooking = ({ competitionType, reCAPTCHAActive }) => {
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [competition, setCompetition] = useState({});
    const [registrations, setRegistrations] = useState([]);
    const [approveReCAPTCHA, setApproveReCAPTCHA] = useState(false);
    const [error, setError] = useState('');
    const [info, setInfo] = useState('');

    const recaptchaRef = useRef();

    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        let getRegistrations = GoogleSheetsService.getRegistrations(competitionType, queryParams.get("c"), queryParams.get("b"));
        let getCompetition = GoogleSheetsService.getCompetition(competitionType, queryParams.get("c"));
        
        Promise.all([getRegistrations, getCompetition]).then((result) => {
            if (result !== null) {
                if (competitionType === 2 && result[0] !== undefined && result[0] !== null) {
                    result[0].forEach(_ => _.dinnerOption = _.dinner === true ? "1" : "2");
                    result[0].forEach(_ => _.alreadyRegistered = false);
                }
                setRegistrations(result[0]);
                setCompetition(result[1]);
                setLoading(false);
            }
        });
    }, [competitionType]);

    const getEmail = () => {
        if (competitionType === 1) {
            return 'golf@stay4golf.se';
        } else {
            return 'info@stay4golf.se';
        }
    }

    const updateRegistrations = (registration) => {
        const updatedRegistrations = [...registrations];
        const index = updatedRegistrations.findIndex(_ => _.name === registration.name);
        updatedRegistrations.splice(index, 1, registration);

        if (competitionType === 2) {
            updatedRegistrations.forEach(_ => _.dinner = _.dinnerOption === "1" ? true : false);
        }
        setRegistrations(updatedRegistrations);
    }

    const saveRegistrations = () => {
        updateValidation('', '');
        setSaving(true);

        let recaptchaToken = '';
        if (reCAPTCHAActive === true) {
            recaptchaToken = recaptchaRef.current.getValue();
        }

        if (competitionType === 1) {
            registrations.forEach(p => {
                if (p.handicap.indexOf(',') + p.handicap.indexOf('.') === -2) {
                    p.handicap = p.handicap + ',0';
                }
            });
        }

        const queryParams = new URLSearchParams(window.location.search);
        GoogleSheetsService.updateRegistrations(competitionType, queryParams.get("c"), queryParams.get("b"), registrations, recaptchaToken).then((status) => {
            if (status === 1) {
                updateValidation('Dina ändringar är sparade!', '');
            } else if (status === 2) {
                updateValidation('', 'Tävlingen börjar snart! Du kan tyvärr inte längre avboka eller ändra på din bokning');
            } else {
                updateValidation('', 'Dina ändringar kunde inte spara, vänligen ladda om sidan och försök igen!');
            }
            setSaving(false);
        });
    }

    const updateValidation = (newInfo, newError) => {
        setInfo(newInfo);
        setError(newError);
        clearTimeout(resetInfoTimeoutId);
        resetInfoTimeoutId = setTimeout(() => {
            setInfo('');
            setError('');
        }, 10000);
    }

    const getCompetitionSelectName = () => {
        let name = '';
        if (competitionType === 1) {
            name = `${competition.track} - ${competition.name}, ${competition.startingTime.split('T')[0]} prel. starttid kl. ${competition.startingTime.split('T')[1].substring(0, 5)}`;
        } else {
            name = `${competition.sheetName}`;
        }

        return name;
    }

    return (
        <div className='form-wrapper'>
            {loading === true && <h3 className='s4g-select-competition-type-header'>Hämtar din bokning, vänligen vänta lite...</h3>}
            {loading === false && (registrations === undefined || registrations === null || registrations.length === 0) &&
                <div>
                    <h3 className='s4g-select-competition-type-header'>Vi kan inte hitta din bokning! :(</h3>
                    <p className='s4g-info-text'>Kontrollera att du använt rätt länk från ditt boknings-mail.<br />Om felet kvarstår, vänligen hör av dig till oss via mail <a href={`mailto:${getEmail()}`}>{getEmail()}</a>, eller ringa oss på <a href='tel:040294400' className='s4g-no-wrap'>040 – 29 44 00.</a></p>
                </div>
            }
            {loading === false && registrations !== undefined && registrations !== null && registrations.length > 0 && registrations.filter(p => p.status !== 4).length === 0 &&
                <div>
                    <h3 className='s4g-select-competition-type-header'>Avbokad</h3>
                    <p className='s4g-info-text'>Samtliga spelare för denna tävling är redan avbokade. Om du har några frågor vänligen hör av dig till oss via mail <a href={`mailto:${getEmail()}`}>{getEmail()}</a>, eller ringa oss på <a href='tel:040294400' className='s4g-no-wrap'>040 – 29 44 00.</a></p>
                </div>
            }
            {loading === false && registrations !== undefined && registrations !== null && registrations.filter(p => p.status !== 4).length > 0 &&
                <div>
                    <h3 className='s4g-select-competition-type-header'>{getCompetitionSelectName()}</h3>
                    {competitionType === 1 &&
                        <div>
                            {registrations.filter(p => p.status !== 4).map(p => {
                                const queryParams = new URLSearchParams(window.location.search);
                                return (
                                    <PlayerForm
                                        key={p.name}
                                        player={p}
                                        updatePlayer={updateRegistrations}
                                        enableCancel={true}
                                        competitionId={queryParams.get("c")}
                                        updateValidation={updateValidation}
                                        isBlueTeeAvailable={competition.isBlueTeeAvailable} />
                                )
                            })}
                        </div>
                    }

                    {competitionType === 2 &&
                        <div>
                            {registrations.filter(p => p.status !== 4).map(p => {
                                const queryParams = new URLSearchParams(window.location.search);
                                return (
                                    <PlayerSummerTourForm
                                        key={p.name}
                                        disableName={true}
                                        disableGolfId={true}
                                        player={p}
                                        updatePlayer={updateRegistrations}
                                        enableCancel={true}
                                        competitionId={queryParams.get("c")}
                                        updateValidation={updateValidation} />
                                )
                            })}
                        </div>
                    }
                    <ValidationFeedback validationInfo={info} validationError={error} />
                    <div className='s4g-section s4g-save-changes'>
                        {reCAPTCHAActive === true &&
                            <ReCAPTCHA ref={recaptchaRef} hl="sv" sitekey="6LdbqJIeAAAAALRadjMPe9Ac5J3bJcHY073llqAl" onChange={e => { setApproveReCAPTCHA(true) }} />
                        }
                        <LoadingButton
                            loading={saving}
                            disabled={!approveReCAPTCHA && reCAPTCHAActive}
                            variant="contained"
                            loadingPosition="start"
                            startIcon={<SaveIcon />}
                            onClick={saveRegistrations}>
                            Spara ändringar
                        </LoadingButton>
                    </div>
                </div>
            }
        </div>
    );
}

export default HandleCompetitionBooking;
